<app-modal #modal2 class="panel-modal" [maximizable]="false" [backdrop]="false">
    <ng-container class="app-modal-header">
        <h5 class="text" [innerHtml]="'calculator'|translate"></h5>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-calculator [isFilterDrop]="filter.advance"></app-calculator>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="advanced-filter">
            <div class="advanced-options">
                <a *ngIf="!filter.advance" class="dropdownMenuButton" [ngClass]="filter.advance?'active':''"
                    href="javascript:;" (click)="showAdvance()" style="justify-content: center;">
                    {{'buy_sell_detail.show_all_coin'|translate}}
                    <img style="width: 10px; height: 10px;" src="./assets/img/obsidiam_arrow-down.svg" alt="" />
                </a>

                <a *ngIf="filter.advance" class="dropdownMenuButton" [ngClass]="filter.advance?'active':''"
                    href="javascript:;" (click)="showAdvance()" style="justify-content: center;">
                    {{'buy_sell_detail.go_back'|translate}}
                    <img style="width: 10px; height: 10px;" src="./assets/img/obsidiam_arrow-down.svg" alt="">
                </a>
            </div>
        </div>
    </ng-container>
</app-modal>